
/**
 * Calculate the number of days between two dates
 */
export const calculateDurationDays = (startDate: string, endDate: string): number => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  
  // Check if the dates are the same day
  if (
    start.getFullYear() === end.getFullYear() &&
    start.getMonth() === end.getMonth() &&
    start.getDate() === end.getDate()
  ) {
    return 1; // If same day, duration is 1 day
  }
  
  // For different dates, calculate the actual difference in days
  // We add 1 because we want the inclusive count (e.g., 24th to 25th is 2 days)
  const startDateOnly = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  const endDateOnly = new Date(end.getFullYear(), end.getMonth(), end.getDate());
  const diffTime = Math.abs(endDateOnly.getTime() - startDateOnly.getTime());
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
  
  return diffDays;
};
